const CATEGORY_CLASS_MAP = {
  // Features
  features: 'features',
  feature: 'features',
  // Arcade IRL
  'arcade/irl': 'arcade-irl',
  'arcade irl': 'arcade-irl',
  'arcade-irl': 'arcade-irl',
  // Effects
  effects: 'effects',
  effect: 'effects',
  // Core
  core: 'core',
  // Visual (formerly "Visual Components")
  visual: 'visual',
  'visual components': 'visual',
  'visual component': 'visual',
  components: 'visual',
  component: 'visual',
  // Text
  text: 'text',
  // Legacy mappings (keep resolving to nearest new category)
  media: 'visual',
  shape: 'visual',
};

const CATEGORY_COLOR_MAP = {
  features: '#789933',
  'arcade-irl': '#216FAF',
  effects: '#E16E01',
  core: '#4F3090',
  visual: '#FF295B',
  text: '#EEA91E',
  misc: '#64748b',
};

const toCategoryClass = (value) => {
  if (typeof value !== 'string') return null;

  const normalized = value.trim().toLowerCase();
  if (!normalized) return null;

  return CATEGORY_CLASS_MAP[normalized] || normalized.replace(/\s+/g, '-');
};

export const getIconCategoryClass = (category) => {
  if (Array.isArray(category)) {
    for (const entry of category) {
      const resolved = toCategoryClass(entry);
      if (resolved) return resolved;
    }
    return 'misc';
  }

  return toCategoryClass(category) || 'misc';
};

export const getIconCategoryColor = (category) => {
  const resolvedClass = getIconCategoryClass(category);
  return CATEGORY_COLOR_MAP[resolvedClass] || CATEGORY_COLOR_MAP.misc;
};

export default getIconCategoryClass;